import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { containerQueries } from './AssetListItem';

export const AssetListItemDetails = ({ sx, ...rest }: StackProps) => (
	<Stack
		sx={combineSx(
			{
				flexDirection: 'row',
				columnGap: 300,
				rowGap: 150,
				alignItems: 'center',
				flexWrap: 'wrap',
				justifyContent: {
					[containerQueries[0]]: 'start',
					[containerQueries[820]]: 'end',
				},
				gridArea: 'details',
			},
			sx,
		)}
		{...rest}
	/>
);

export default AssetListItemDetails;
